import { setCookie } from "@/util/cookie.ts";

/** The property the container's Google tag sends to (GTM-NW5ZWW72). */
const GA4_MEASUREMENT_ID = "G-273TQDHF3N";

/** Read by baseQuery.ts, which sends it with the sign-up's first request. */
export const GA_SESSION_ID_COOKIE = "gaSessionId";

/**
 * Keeps the visitor's Ga4 session id for the sign-up management-api sends to
 * our tagging server, so that event joins the session the visit started.
 * Asked for while signed out, the only time the container is loaded
 * (GoogleTagManagerScript), and before a Google sign-in leaves the page.
 *
 * gtag's documented `get` (developers.google.com/tag-platform/gtagjs/reference#get),
 * queued on the data layer for the container's Google tag to answer. Nothing
 * answers where analytics consent was refused or the container never loaded,
 * and the sign-up then goes without a session id.
 */
export function rememberGaSessionId(): void {
    window.dataLayer = window.dataLayer || [];
    // gtag's own shape: the Google tag reads an Arguments object, not an array.
    function gtag(..._args: unknown[]) {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer?.push(arguments);
    }
    gtag("get", GA4_MEASUREMENT_ID, "session_id", (sessionId: unknown) => {
        if (typeof sessionId === "number" || typeof sessionId === "string") {
            setCookie(GA_SESSION_ID_COOKIE, String(sessionId), 14);
        }
    });
}
